// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading_headingContainer__e3lvr {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.heading_title__fi14a {
  color: var(--gray-900, #101828);
  font-family: Poppins, sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 38px;
}`, "",{"version":3,"sources":["webpack://./src/modules/molecules/heading/heading.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,+BAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@500;600&display=swap\");\n\n.headingContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title {\n  color: var(--gray-900, #101828);\n  font-family: Poppins, sans-serif;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 38px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingContainer": `heading_headingContainer__e3lvr`,
	"title": `heading_title__fi14a`
};
export default ___CSS_LOADER_EXPORT___;
